import React from 'react';
import PropTypes from 'prop-types';
import { HorseLink } from '../links/ProfileLink';

const EntriesHorseLink = ({
    damCountryCode,
    damName,
    damUid,
    horseAge,
    horseCountryCode,
    horseName,
    horseUid,
    isDamShown,
}) => (
    <span>
        <HorseLink
            horseStyleName={horseName}
            horseUid={horseUid}
        />
        { isDamShown && <span className="hp-progenyEntries__dam">
            {` (${horseCountryCode}) `}{horseAge}yo&nbsp;—&nbsp;
            <HorseLink
                className="hp-progenyEntries__regularLink"
                horseStyleName={damName}
                horseUid={damUid}
            />
            {` (${damCountryCode})`}
        </span>}
    </span>
);

EntriesHorseLink.propTypes = {
    damCountryCode: PropTypes.string,
    damName: PropTypes.string,
    damUid: PropTypes.number,
    horseAge: PropTypes.number,
    horseCountryCode: PropTypes.string,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    isDamShown: PropTypes.bool,
};

export default EntriesHorseLink;



// WEBPACK FOOTER //
// ./src/js/shared/entries/EntriesHorseLink.jsx